import { useInfiniteQuery } from "@tanstack/react-query";
import { api } from "../../api";
import type { ListFeedbackItemsParams } from "../../generated/core-api";
import { useEvalStewardEnabled } from "./useEvalStewardEnabled";

const PAGE_SIZE = 25;

export function useFeedbackItems(filter: ListFeedbackItemsParams) {
  const { isEvalStewardEnabled } = useEvalStewardEnabled();

  return useInfiniteQuery({
    queryKey: ["evalSteward", "feedbackItems", filter],
    queryFn: ({ pageParam }) =>
      api.listFeedbackItems({
        ...filter,
        page_size: PAGE_SIZE,
        continuation_token: pageParam ?? undefined,
      }),
    getNextPageParam: (lastPage) => lastPage.continuation_token ?? undefined,
    initialPageParam: undefined as string | undefined,
    enabled: isEvalStewardEnabled,
  });
}
